<!--
 * @Author: 陈大仙人
 * @Date: 2022-07-14 16:33:51
 * @LastEditors: 陈大仙人
 * @LastEditTime: 2024-11-11 17:21:58
 * @FilePath: /akx-pc-main/src/login/App.vue
-->
<template>
  <div id="mainApp" v-if="!login">
    <router-view/>
  </div>
</template>
<script>
export default {
  data() {
    return {
      login: true
    }
  },
  components: {

  },
  created() {
    if(window.localStorage.getItem('AKX_AUTO_LOGIN_CONFIG') !== '-1') {
      this.$api.getCurrentVersion({
        redirect: false,
        success: () => {
          let pathname;
          if (location.pathname.indexOf("login.html") !== -1) {
            pathname = location.pathname.replace("login.html", "index.html");
          } else {
            pathname = "/";
          }
          let url = location.origin + pathname
          location.replace(url);
        },
        fail: () => {
          this.login = false;
        }
      })
    }else {
      this.login = false;
    }
    if(process.env.NODE_ENV === 'production') {
      window.addEventListener('storage', function(res) {
        if(res.key === 'SYS_CONFIG_AND_TOKEN') {
          // The page is now logged back in
          // The page should reload
          location.reload();
        }
      })
    }
  },
  methods: {

  }
}
</script>
<style>
html, body {
  width: 100%;
  height: 100%;
  line-height: 1;
}
#mainApp {
  width: 100%;
  height: 100%;
}

* {
  padding: 0;
  margin: 0;
  vertical-align: baseline;
  border: 0;
  box-sizing: border-box;
  font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", Arial, sans-serif;
}
</style>
